module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-03@2x.7417947.jpg";